export interface TVEpisode {
  id: string;
  title: string;
  episodeNumber: number;
  duration: string;
}

export interface TVSeries {
  id: string;
  title: string;
  category: string;
  categorySlug: string;
  image: string;
  rating: number;
  totalEpisodes: number;
  status: string;
  description: string;
  year: number;
  actors: string[];
  director: string;
  genre: string[];
  region: string;
  updateDay: string;
  isHot: boolean;
  isNew: boolean;
  views: number;
  episodes: TVEpisode[];
  content: string;
}

export interface Category {
  name: string;
  slug: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  { name: '全部剧集', slug: 'all', icon: 'ri-movie-line', description: '浏览所有电视剧，发现你喜欢的精彩内容' },
  { name: '国产剧', slug: 'chinese', icon: 'ri-china-railway-line', description: '最新热播国产电视剧，精彩国剧不断' },
  { name: '韩剧', slug: 'korean', icon: 'ri-heart-line', description: '热门韩剧在线观看，浪漫剧情精彩纷呈' },
  { name: '美剧', slug: 'american', icon: 'ri-flag-line', description: '高分美剧全集，紧张刺激不容错过' },
  { name: '日剧', slug: 'japanese', icon: 'ri-sun-line', description: '经典日剧推荐，温暖治愈的故事' },
  { name: '动漫', slug: 'anime', icon: 'ri-ghost-line', description: '热门动漫在线，热血冒险一网打尽' },
];

export const tvSeriesData: TVSeries[] = [
  {
    id: 'drama-1',
    title: '长安十二时辰',
    category: '国产剧',
    categorySlug: 'chinese',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20dynasty%20drama%20poster%20with%20Tang%20Dynasty%20warrior%20in%20red%20armor%20standing%20on%20city%20wall%20at%20sunset%2C%20cinematic%20lighting%2C%20epic%20composition%2C%20movie%20poster%20style%2C%20dark%20moody%20background&width=600&height=800&seq=wowo-drama-1&orientation=portrait',
    rating: 8.6,
    totalEpisodes: 48,
    status: '已完结',
    description: '唐朝天宝三年，上元节前夕，长安城陷入危机。死囚张小敬临危受命，与少年名士李必携手在十二时辰内拯救长安。一场惊心动魄的较量就此展开...',
    year: 2019,
    actors: ['雷佳音', '易烊千玺', '周一围', '热依扎'],
    director: '曹盾',
    genre: ['古装', '悬疑', '历史'],
    region: '中国大陆',
    updateDay: '已完结',
    isHot: true,
    isNew: false,
    views: 5230000,
    episodes: Array.from({ length: 48 }, (_, i) => ({
      id: `drama-1-ep-${i + 1}`,
      title: `第${i + 1}集`,
      episodeNumber: i + 1,
      duration: '45分钟',
    })),
    content: '《长安十二时辰》是由曹盾执导，雷佳音、易烊千玺领衔主演的古装悬疑剧。该剧改编自马伯庸的同名小说，讲述了唐朝天宝三年上元节前夕，长安城陷入危机，死囚张小敬临危受命，与少年名士李必携手在十二时辰内拯救长安的故事。\n\n剧中，张小敬（雷佳音 饰）原是一名死囚，因上元节前夕长安城面临一场巨大的阴谋，他被靖安司司丞李必（易烊千玺 饰）从死牢中提调出来，要求他在十二时辰内找出幕后黑手，拯救长安百姓。在这场与时间赛跑的较量中，张小敬展现出了非凡的智慧和勇气。\n\n该剧制作精良，场景布置高度还原唐代风貌，服装道具考究，灯光摄影达到了电影级别。演员表演精湛，尤其是雷佳音饰演的张小敬，将一个复杂而立体的角色演绎得入木三分。剧情紧凑悬疑，环环相扣，让观众欲罢不能。',
  },
  {
    id: 'drama-2',
    title: '狂飙',
    category: '国产剧',
    categorySlug: 'chinese',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20crime%20thriller%20drama%20poster%20with%20two%20men%20in%20dark%20suits%20facing%20each%20other%20under%20streetlight%2C%20noir%20cinematic%20style%2C%20rainy%20night%20atmosphere%2C%20intense%20dramatic%20lighting&width=600&height=800&seq=wowo-drama-2&orientation=portrait',
    rating: 8.9,
    totalEpisodes: 39,
    status: '已完结',
    description: '一部跨越二十年的扫黑除恶斗争史诗，讲述了警察安欣与黑恶势力长达二十年的生死较量。正义与邪恶的对决，人性的挣扎与抉择...',
    year: 2023,
    actors: ['张译', '张颂文', '李一桐', '张志坚'],
    director: '徐纪周',
    genre: ['犯罪', '剧情', '悬疑'],
    region: '中国大陆',
    updateDay: '已完结',
    isHot: true,
    isNew: false,
    views: 8750000,
    episodes: Array.from({ length: 39 }, (_, i) => ({
      id: `drama-2-ep-${i + 1}`,
      title: `第${i + 1}集`,
      episodeNumber: i + 1,
      duration: '45分钟',
    })),
    content: '《狂飙》是由徐纪周执导，张译、张颂文领衔主演的扫黑除恶题材电视剧。该剧讲述了以一线刑警安欣为代表的正义力量，与以高启强为首的黑恶势力长达二十年的生死较量。\n\n故事横跨2000年至2021年，通过群像叙事的方式展现了扫黑除恶工作中的复杂性和艰巨性。安欣（张译 饰）从一个热血青年刑警成长为成熟稳重的扫黑英雄，而高启强（张颂文 饰）则从一个底层鱼贩逐步堕落为黑社会头目。\n\n该剧以真实案件为背景，剧情扣人心弦，人物塑造丰满立体。张颂文饰演的高启强更是被誉为华语电视剧史上最具魅力的反派之一。剧中对人性的深刻剖析和对社会现实的反思引发了广泛讨论。',
  },
  {
    id: 'drama-3',
    title: '黑暗荣耀',
    category: '韩剧',
    categorySlug: 'korean',
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20poster%20with%20elegant%20woman%20in%20black%20dress%20standing%20in%20front%20of%20luxurious%20mansion%2C%20dark%20moody%20atmosphere%2C%20revenge%20theme%2C%20cinematic%20lighting%2C%20cold%20color%20tone&width=600&height=800&seq=wowo-drama-3&orientation=portrait',
    rating: 8.7,
    totalEpisodes: 16,
    status: '已完结',
    description: '年少时遭受校园暴力的女子，精心策划了一场复仇大计。她成为了仇人孩子的班主任，一场冷酷而完美的复仇就此展开...',
    year: 2022,
    actors: ['宋慧乔', '李到晛', '林智妍', '郑成日'],
    director: '安吉镐',
    genre: ['剧情', '复仇', '悬疑'],
    region: '韩国',
    updateDay: '已完结',
    isHot: true,
    isNew: false,
    views: 4620000,
    episodes: Array.from({ length: 16 }, (_, i) => ({
      id: `drama-3-ep-${i + 1}`,
      title: `第${i + 1}集`,
      episodeNumber: i + 1,
      duration: '50分钟',
    })),
    content: '《黑暗荣耀》是由安吉镐执导，金恩淑编剧，宋慧乔、李到晛主演的Netflix韩国复仇剧。该剧讲述了年少时遭受校园暴力而灵魂破碎的文东恩（宋慧乔 饰），用尽一生精心策划了一场向加害者和旁观者复仇的故事。\n\n文东恩在高中时期遭受了以朴妍珍（林智妍 饰）为首的富家子弟团体的残忍霸凌，被迫退学后，她用了十几年的时间精心布局。她成为了朴妍珍女儿的班主任，并一步步接近当年的所有加害者。\n\n该剧以其精湛的剧本、出色的演技和独特的叙事风格获得了全球观众的喜爱。宋慧乔的转型演出令人惊艳，将一个内心充满仇恨却外表冷静克制的复仇者形象刻画得入木三分。',
  },
  {
    id: 'drama-4',
    title: '琅琊榜',
    category: '国产剧',
    categorySlug: 'chinese',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%20with%20scholar%20in%20white%20robe%20holding%20fan%20standing%20on%20mountain%20peak%2C%20misty%20landscape%2C%20traditional%20Chinese%20ink%20painting%20style%2C%20elegant%20composition&width=600&height=800&seq=wowo-drama-4&orientation=portrait',
    rating: 9.3,
    totalEpisodes: 54,
    status: '已完结',
    description: '十二年前，七万赤焰军被奸人所害，含冤埋骨梅岭。十二年后，麒麟才子梅长苏重返帝都，掀起了一场惊心动魄的宫廷权谋之战...',
    year: 2015,
    actors: ['胡歌', '刘涛', '王凯', '陈龙'],
    director: '孔笙',
    genre: ['古装', '权谋', '剧情'],
    region: '中国大陆',
    updateDay: '已完结',
    isHot: false,
    isNew: false,
    views: 10200000,
    episodes: Array.from({ length: 54 }, (_, i) => ({
      id: `drama-4-ep-${i + 1}`,
      title: `第${i + 1}集`,
      episodeNumber: i + 1,
      duration: '45分钟',
    })),
    content: '《琅琊榜》是由孔笙、李雪执导，胡歌、刘涛、王凯领衔主演的古装权谋剧。该剧改编自海宴的同名网络小说，以平反冤案、扶持明君、振兴山河为主线。\n\n剧中，"麒麟才子"梅长苏（胡歌 饰）以病弱之躯背负血海深仇，凭借无双智计搅动朝堂风云。十二年前，七万赤焰军将士含冤被害，梅长苏作为幸存者，化名苏哲重返帝都金陵，以谋士身份辅佐靖王萧景琰（王凯 饰），一步步揭开当年的真相。\n\n该剧被誉为"华语古装剧巅峰之作"，无论是剧本、表演、制作还是配乐都达到了极高的水准。胡歌饰演的梅长苏温润如玉却心机深沉，成为华语电视剧史上最经典的角色之一。',
  },
  {
    id: 'drama-5',
    title: '鱿鱼游戏',
    category: '韩剧',
    categorySlug: 'korean',
    image: 'https://readdy.ai/api/search-image?query=Korean%20survival%20drama%20poster%20with%20people%20in%20green%20tracksuits%20standing%20in%20colorful%20staircase%20room%2C%20geometric%20pastel%20colors%2C%20mysterious%20and%20tense%20atmosphere%2C%20pink%20guards%20in%20background&width=600&height=800&seq=wowo-drama-5&orientation=portrait',
    rating: 7.9,
    totalEpisodes: 9,
    status: '已完结',
    description: '456名陷入绝境的人收到神秘邀请，参加一场奖金高达456亿韩元的儿童游戏。但输掉的人，将会付出生命的代价...',
    year: 2021,
    actors: ['李政宰', '朴海秀', '魏嘏隽', '郑好娟'],
    director: '黄东赫',
    genre: ['惊悚', '剧情', '悬疑'],
    region: '韩国',
    updateDay: '已完结',
    isHot: false,
    isNew: false,
    views: 6800000,
    episodes: Array.from({ length: 9 }, (_, i) => ({
      id: `drama-5-ep-${i + 1}`,
      title: `第${i + 1}集`,
      episodeNumber: i + 1,
      duration: '55分钟',
    })),
    content: '《鱿鱼游戏》是由黄东赫执导并编剧，李政宰、朴海秀主演的Netflix韩国原创剧。该剧讲述了一群走投无路的人收到神秘邀请，参加一场生死游戏的故事。\n\n456名因债务、家庭等各种原因陷入绝境的人被带到一个与世隔绝的孤岛上，参加六轮儿童游戏。获胜者可以获得456亿韩元的奖金，但失败者将当场毙命。主角成奇勋（李政宰 饰）是一名欠下巨额赌债的中年男子，他在游戏中结识了不同背景的参赛者，在生死考验中展现出人性的复杂。\n\n该剧以其独特的视觉风格、紧张的剧情和对社会现实的讽刺成为全球现象级作品，是Netflix有史以来观看量最高的剧集。',
  },
  {
    id: 'drama-6',
    title: '庆余年',
    category: '国产剧',
    categorySlug: 'chinese',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20historical%20drama%20poster%20with%20young%20man%20in%20ancient%20blue%20robe%20holding%20sword%2C%20dramatic%20sky%20with%20dragons%2C%20epic%20fantasy%20illustration%20style%2C%20vibrant%20colors&width=600&height=800&seq=wowo-drama-6&orientation=portrait',
    rating: 8.3,
    totalEpisodes: 46,
    status: '已完结',
    description: '一个患有重症肌无力的现代青年，穿越到古代成为一个婴儿。带着现代思维和记忆的他，在这个陌生的世界里开始了传奇的一生...',
    year: 2019,
    actors: ['张若昀', '李沁', '陈道明', '吴刚'],
    director: '孙皓',
    genre: ['古装', '奇幻', '喜剧'],
    region: '中国大陆',
    updateDay: '已完结',
    isHot: false,
    isNew: false,
    views: 5900000,
    episodes: Array.from({ length: 46 }, (_, i) => ({
      id: `drama-6-ep-${i + 1}`,
      title: `第${i + 1}集`,
      episodeNumber: i + 1,
      duration: '45分钟',
    })),
    content: '《庆余年》是由孙皓执导，张若昀、李沁、陈道明、吴刚领衔主演的古装传奇剧。该剧改编自猫腻的同名小说，讲述了一个身世神秘的少年范闲，历经家族、江湖、庙堂的种种考验与锤炼的故事。\n\n范闲（张若昀 饰）自幼在澹州长大，跟随五竹叔和费介师父学习武艺和毒术。十六岁时，他来到京都，踏入风云变幻的朝堂。在京都，他凭借过人的智慧和现代知识，在各方势力间游走周旋，同时追寻自己身世的真相。\n\n该剧融合了奇幻、权谋、喜剧等多种元素，节奏明快，人物鲜明。陈道明饰演的庆帝气场强大，吴刚饰演的陈萍萍深不可测，张若昀则完美诠释了范闲这个聪慧机敏又不失纯真的角色。',
  },
  {
    id: 'drama-7',
    title: '怪奇物语',
    category: '美剧',
    categorySlug: 'american',
    image: 'https://readdy.ai/api/search-image?query=American%20sci-fi%20horror%20drama%20poster%20with%20kids%20on%20bicycles%20at%20night%20under%20red%20sky%2C%201980s%20retro%20style%2C%20neon%20title%2C%20mysterious%20creature%20silhouette%2C%20nostalgic%20film%20poster&width=600&height=800&seq=wowo-drama-7&orientation=portrait',
    rating: 8.8,
    totalEpisodes: 34,
    status: '更新中',
    description: '在美国印第安纳州霍金斯小镇，一名小男孩神秘失踪。他的朋友们在寻找他的过程中，发现了一个关于秘密实验、超自然力量和另一个维度的惊天秘密...',
    year: 2016,
    actors: ['米莉·波比·布朗', '芬恩·伍法德', '薇诺娜·瑞德', '大卫·哈伯'],
    director: '达菲兄弟',
    genre: ['科幻', '恐怖', '剧情'],
    region: '美国',
    updateDay: '待更新',
    isHot: true,
    isNew: false,
    views: 7100000,
    episodes: Array.from({ length: 34 }, (_, i) => ({
      id: `drama-7-ep-${i + 1}`,
      title: `第${i + 1}集`,
      episodeNumber: i + 1,
      duration: '50分钟',
    })),
    content: '《怪奇物语》是由达菲兄弟创作的美国科幻恐怖剧集，在Netflix播出。故事背景设定在1980年代的印第安纳州霍金斯小镇。\n\n小男孩威尔·拜尔斯神秘失踪后，他的朋友们——迈克、达斯汀和卢卡斯在寻找他的过程中，遇到了一个拥有超能力的女孩十一（米莉·波比·布朗 饰）。与此同时，威尔的母亲乔伊斯（薇诺娜·瑞德 饰）和警长霍普（大卫·哈伯 饰）也各自展开了调查。\n\n他们发现霍金斯小镇隐藏着一个巨大的秘密——一个名为"霍金斯国家实验室"的秘密政府机构正在进行超自然实验，并意外打开了通往另一个维度"颠倒世界"的大门。该剧完美融合了科幻、恐怖和成长题材，向1980年代的流行文化致敬。',
  },
  {
    id: 'drama-8',
    title: '逃避虽可耻但有用',
    category: '日剧',
    categorySlug: 'japanese',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20romantic%20comedy%20drama%20poster%20with%20couple%20in%20cozy%20apartment%2C%20warm%20lighting%2C%20clean%20minimalist%20Japanese%20style%2C%20happy%20smiling%20atmosphere%2C%20soft%20pastel%20colors&width=600&height=800&seq=wowo-drama-8&orientation=portrait',
    rating: 8.4,
    totalEpisodes: 11,
    status: '已完结',
    description: '一位心理学研究生毕业却找不到工作的女性，与一位不善交际的程序员签订契约结婚。一场从"雇佣关系"开始的婚姻，会走向何方？',
    year: 2016,
    actors: ['新垣结衣', '星野源', '大谷亮平', '石田百合子'],
    director: '金子文纪',
    genre: ['爱情', '喜剧', '剧情'],
    region: '日本',
    updateDay: '已完结',
    isHot: false,
    isNew: false,
    views: 3200000,
    episodes: Array.from({ length: 11 }, (_, i) => ({
      id: `drama-8-ep-${i + 1}`,
      title: `第${i + 1}集`,
      episodeNumber: i + 1,
      duration: '45分钟',
    })),
    content: '《逃避虽可耻但有用》是由金子文纪执导，野木亚纪子编剧，新垣结衣、星野源主演的日本爱情喜剧。该剧改编自海野纲弥的同名漫画。\n\n剧中，森山实栗（新垣结衣 饰）虽然拥有心理学研究生学历，却一直找不到正式工作。在父亲的介绍下，她成为了一名IT工程师津崎平匡（星野源 饰）的家政服务员。当实栗的父母要搬走时，两人为了各自的需求，决定"契约结婚"——以雇佣关系为基础，表面上是一对夫妻。\n\n这部温暖治愈的爱情喜剧不仅展现了两个羞涩内向的人如何逐渐走近彼此，还探讨了现代社会中婚姻、工作和女性价值等深刻话题。新垣结衣和星野源的化学反应极佳，"恋舞"更是风靡全亚洲。',
  },
  {
    id: 'drama-9',
    title: '三体',
    category: '国产剧',
    categorySlug: 'chinese',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20drama%20poster%20with%20three%20suns%20in%20cosmic%20sky%2C%20mysterious%20alien%20civilization%20theme%2C%20dark%20space%20background%20with%20stars%2C%20futuristic%20and%20philosophical%20tone&width=600&height=800&seq=wowo-drama-9&orientation=portrait',
    rating: 8.1,
    totalEpisodes: 30,
    status: '已完结',
    description: '科学家汪淼在调查一系列科学家自杀事件时，被卷入了一场关乎全人类命运的宇宙级危机。一个来自三体文明的消息，改变了人类的未来...',
    year: 2023,
    actors: ['张鲁一', '于和伟', '陈瑾', '王子文'],
    director: '杨磊',
    genre: ['科幻', '悬疑', '剧情'],
    region: '中国大陆',
    updateDay: '已完结',
    isHot: true,
    isNew: true,
    views: 4100000,
    episodes: Array.from({ length: 30 }, (_, i) => ({
      id: `drama-9-ep-${i + 1}`,
      title: `第${i + 1}集`,
      episodeNumber: i + 1,
      duration: '45分钟',
    })),
    content: '《三体》是由杨磊执导，张鲁一、于和伟、陈瑾、王子文领衔主演的科幻剧。该剧改编自刘慈欣的同名科幻小说，是中国科幻文学的里程碑之作。\n\n故事从2007年开始，纳米材料科学家汪淼（张鲁一 饰）被警官史强（于和伟 饰）带到联合作战中心，调查全球科学家离奇自杀事件。在调查中，汪淼接触到了一个名为"科学边界"的组织，并逐渐揭开了一个惊天秘密——在4光年外的三体星系，一个外星文明正在向地球进发。\n\n该剧忠实还原了原著宏大的科幻世界观，同时在人物塑造和情感表达上做了细致入微的处理。"古筝行动"等经典场景的视觉呈现令人震撼。《三体》不仅是一部科幻剧，更是对人类文明的深刻反思。',
  },
  {
    id: 'drama-10',
    title: '鬼灭之刃',
    category: '动漫',
    categorySlug: 'anime',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20demon%20slayer%20poster%20with%20young%20swordsman%20in%20green%20checkered%20haori%20holding%20katana%2C%20water%20breathing%20effect%2C%20dynamic%20action%20pose%2C%20vibrant%20anime%20art%20style&width=600&height=800&seq=wowo-drama-10&orientation=portrait',
    rating: 9.0,
    totalEpisodes: 55,
    status: '更新中',
    description: '大正时代，少年灶门炭治郎全家被鬼杀害，唯一幸存的妹妹祢豆子却变成了鬼。为了让妹妹恢复成人类，炭治郎踏上了成为鬼杀队员的征程...',
    year: 2019,
    actors: ['花江夏树', '鬼头明里', '下野纮', '松冈祯丞'],
    director: '外崎春雄',
    genre: ['热血', '战斗', '冒险'],
    region: '日本',
    updateDay: '待更新',
    isHot: true,
    isNew: false,
    views: 8900000,
    episodes: Array.from({ length: 55 }, (_, i) => ({
      id: `drama-10-ep-${i + 1}`,
      title: `第${i + 1}集`,
      episodeNumber: i + 1,
      duration: '24分钟',
    })),
    content: '《鬼灭之刃》是由吾峠呼世晴创作的同名漫画改编的日本电视动画，由ufotable制作。故事背景设定在日本大正时代。\n\n主角灶门炭治郎是一名善良的卖炭少年。一天，他全家被鬼杀害，唯一幸存的妹妹祢豆子却变成了鬼。为了寻找让妹妹变回人类的方法，炭治郎加入了鬼杀队，踏上了斩杀恶鬼、守护人类的道路。\n\n该动画以其精美的制作、华丽的战斗场面和感人至深的情感刻画获得了全球观众的喜爱。《鬼灭之刃 无限列车篇》剧场版更是打破了日本电影票房历史纪录。灶门炭治郎的善良与坚韧，祢豆子的可爱与强大，以及众多性格鲜明的角色共同构建了一个令人着迷的世界。',
  },
  {
    id: 'drama-11',
    title: '绝命毒师',
    category: '美剧',
    categorySlug: 'american',
    image: 'https://readdy.ai/api/search-image?query=American%20crime%20drama%20poster%20with%20middle-aged%20man%20in%20yellow%20hazmat%20suit%20in%20desert%2C%20dark%20moody%20tone%2C%20dramatic%20sky%2C%20minimalist%20poster%20design&width=600&height=800&seq=wowo-drama-11&orientation=portrait',
    rating: 9.5,
    totalEpisodes: 62,
    status: '已完结',
    description: '一位平凡的高中化学老师，在被诊断出癌症后，为了给家人留下足够的钱，开始利用自己的化学知识制造冰毒。一个普通人的堕落之路，就此展开...',
    year: 2008,
    actors: ['布莱恩·科兰斯顿', '亚伦·保尔', '安娜·冈', '迪恩·诺里斯'],
    director: '文斯·吉里根',
    genre: ['犯罪', '剧情', '惊悚'],
    region: '美国',
    updateDay: '已完结',
    isHot: false,
    isNew: false,
    views: 9500000,
    episodes: Array.from({ length: 62 }, (_, i) => ({
      id: `drama-11-ep-${i + 1}`,
      title: `第${i + 1}集`,
      episodeNumber: i + 1,
      duration: '47分钟',
    })),
    content: '《绝命毒师》是由文斯·吉里根创作的美国犯罪剧情电视剧，被广泛认为是有史以来最伟大的电视剧之一。\n\n故事主角沃尔特·怀特（布莱恩·科兰斯顿 饰）是一位在新墨西哥州阿尔伯克基教书的高中化学老师。当他被诊断出患有晚期肺癌后，为了确保家人未来的经济安全，他决定利用自己的化学专业知识，与前学生杰西·平克曼（亚伦·保尔 饰）合作制造和销售冰毒。\n\n从一个"为了家人"的初衷开始，沃尔特逐渐陷入了毒品世界的黑暗深渊，他的人格从温和的"怀特先生"蜕变成了冷酷无情的"海森堡"。该剧对人性、道德和选择的探讨深刻而震撼，布莱恩·科兰斯顿的表演堪称教科书级别。',
  },
  {
    id: 'drama-12',
    title: '孤独的美食家',
    category: '日剧',
    categorySlug: 'japanese',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20food%20drama%20poster%20with%20middle-aged%20man%20eating%20delicious%20ramen%20happily%2C%20warm%20restaurant%20lighting%2C%20Japanese%20street%20food%20scene%2C%20appetizing%20food%20photography%2C%20cozy%20atmosphere&width=600&height=800&seq=wowo-drama-12&orientation=portrait',
    rating: 8.5,
    totalEpisodes: 96,
    status: '更新中',
    description: '进口杂货商井之头五郎，在工作间隙寻找各种美食的故事。一个人的美食之旅，每一餐都是与美好的邂逅...',
    year: 2012,
    actors: ['松重丰'],
    director: '溝口憲司',
    genre: ['美食', '剧情', '治愈'],
    region: '日本',
    updateDay: '每周五更新',
    isHot: false,
    isNew: false,
    views: 2800000,
    episodes: Array.from({ length: 96 }, (_, i) => ({
      id: `drama-12-ep-${i + 1}`,
      title: `第${i + 1}集`,
      episodeNumber: i + 1,
      duration: '24分钟',
    })),
    content: '《孤独的美食家》是由久住昌之创作、谷口治郎作画的同名漫画改编的日本美食电视剧，由松重丰主演。\n\n该剧讲述了进口杂货商井之头五郎在日本各地跑业务的过程中，在工作间隙寻找各种美食的故事。五郎的品味独特，他不去高级餐厅，而是偏爱街头巷尾那些不起眼但味道极佳的小店。\n\n每一集，五郎都会在完成工作后感到"肚子饿了"，然后开始他的美食寻觅之旅。从拉面、烤肉到天妇罗、寿司，五郎对每一道美食都充满了敬意和热爱。松重丰细腻的表演和剧中美食的诱人呈现，让观众在追剧的同时也能感受到美食带来的幸福感。',
  },
  {
    id: 'drama-13',
    title: '半泽直树',
    category: '日剧',
    categorySlug: 'japanese',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20business%20drama%20poster%20with%20man%20in%20sharp%20business%20suit%20looking%20determined%2C%20corporate%20office%20background%2C%20intense%20gaze%2C%20dramatic%20lighting%2C%20bank%20setting&width=600&height=800&seq=wowo-drama-13&orientation=portrait',
    rating: 8.8,
    totalEpisodes: 20,
    status: '已完结',
    description: '银行职员半泽直树，面对职场的不公和陷害，以"以牙还牙，加倍奉还"为座右铭，展开了一场酣畅淋漓的职场反击战...',
    year: 2013,
    actors: ['堺雅人', '上户彩', '香川照之', '及川光博'],
    director: '福泽克雄',
    genre: ['职场', '剧情', '悬疑'],
    region: '日本',
    updateDay: '已完结',
    isHot: false,
    isNew: false,
    views: 3700000,
    episodes: Array.from({ length: 20 }, (_, i) => ({
      id: `drama-13-ep-${i + 1}`,
      title: `第${i + 1}集`,
      episodeNumber: i + 1,
      duration: '54分钟',
    })),
    content: '《半泽直树》是由池井户润的同名小说改编的日本职场电视剧，由堺雅人主演。该剧讲述了银行职员半泽直树在职场上面对各种不公和陷害，坚持自己的信念进行反击的故事。\n\n半泽直树（堺雅人 饰）是东京中央银行的一名职员，他坚信"人若犯我，我必加倍奉还"的信条。当他的上司为了推卸责任而将他作为替罪羊时，半泽直树没有选择忍气吞声，而是凭借自己出色的业务能力和敏锐的洞察力，展开了精彩的职场反击。\n\n该剧以其高强度的人物冲突、精彩的台词和堺雅人等演员的精湛演技，在日本和亚洲各地都创下了惊人的收视记录。"加倍奉还"更是成为了现象级的流行语。',
  },
  {
    id: 'drama-14',
    title: '权力的游戏',
    category: '美剧',
    categorySlug: 'american',
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20epic%20drama%20poster%20with%20iron%20throne%20made%20of%20swords%2C%20dark%20medieval%20atmosphere%2C%20dragons%20silhouette%20in%20sky%2C%20epic%20fantasy%20illustration%2C%20dramatic%20lighting&width=600&height=800&seq=wowo-drama-14&orientation=portrait',
    rating: 9.2,
    totalEpisodes: 73,
    status: '已完结',
    description: '维斯特洛大陆上，七大王国的贵族家族为了争夺铁王座而展开权谋斗争。与此同时，远古的邪恶力量正在北境长城之外苏醒...',
    year: 2011,
    actors: ['艾米莉亚·克拉克', '基特·哈灵顿', '彼特·丁拉基', '琳娜·海蒂'],
    director: '大卫·贝尼奥夫',
    genre: ['奇幻', '冒险', '剧情'],
    region: '美国',
    updateDay: '已完结',
    isHot: false,
    isNew: false,
    views: 15000000,
    episodes: Array.from({ length: 73 }, (_, i) => ({
      id: `drama-14-ep-${i + 1}`,
      title: `第${i + 1}集`,
      episodeNumber: i + 1,
      duration: '55分钟',
    })),
    content: '《权力的游戏》是由HBO制作的中世纪史诗奇幻电视剧，改编自乔治·R·R·马丁的小说《冰与火之歌》系列。\n\n故事发生在虚构的维斯特洛大陆上，讲述了史塔克家族、兰尼斯特家族、坦格利安家族等七大王国贵族家族之间为了争夺铁王座而展开的权力斗争。与此同时，在极北之地的长城之外，神秘的"异鬼"正在苏醒，威胁着整个大陆的存亡。\n\n该剧以其宏大的世界观、复杂的人物关系和出人意料的剧情转折闻名于世。剧中的"血色婚礼"、"私生子之战"等经典场景至今仍被观众津津乐道。《权力的游戏》共获得59项艾美奖，创下了电视剧获奖纪录。',
  },
  {
    id: 'drama-15',
    title: '排球少年',
    category: '动漫',
    categorySlug: 'anime',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20sports%20anime%20volleyball%20poster%20with%20team%20jumping%20to%20spike%20ball%2C%20orange%20and%20black%20uniforms%2C%20dynamic%20action%2C%20gymnasium%20setting%2C%20energetic%20and%20motivational%20style&width=600&height=800&seq=wowo-drama-15&orientation=portrait',
    rating: 9.3,
    totalEpisodes: 85,
    status: '更新中',
    description: '身材矮小的日向翔阳，凭借着惊人的跳跃力和对排球的热爱，与天才二传手影山飞雄组成最强搭档，带领乌野高中排球队冲向全国大赛...',
    year: 2014,
    actors: ['村濑步', '石川界人', '日野聪', '入野自由'],
    director: '满仲劝',
    genre: ['运动', '热血', '青春'],
    region: '日本',
    updateDay: '待更新',
    isHot: false,
    isNew: false,
    views: 5500000,
    episodes: Array.from({ length: 85 }, (_, i) => ({
      id: `drama-15-ep-${i + 1}`,
      title: `第${i + 1}集`,
      episodeNumber: i + 1,
      duration: '24分钟',
    })),
    content: '《排球少年！！》是由古馆春一的同名漫画改编的日本运动题材动画，由Production I.G.制作。\n\n故事的主角日向翔阳是一名身材矮小但拥有惊人跳跃力的少年。在初中时偶然看到乌野高中排球队"小巨人"的比赛后，他立志成为像"小巨人"一样的排球选手。考入乌野高中后，日向遇到了天才二传手影山飞雄——这个曾在初中比赛中打败他的对手。\n\n两人从最初的水火不容到逐渐磨合成为最强搭档，带领乌野高中排球队一路披荆斩棘，向全国大赛的目标迈进。该动画以其精彩的比赛描绘、丰富的角色塑造和热血励志的剧情赢得了无数观众的喜爱。',
  },
];